import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Logo from '../../Logo';
import getConfig from '../../../../util/config';

const propTypes = {
  title: PropTypes.string,
  logoSrc: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

const Title = ({ title, logoSrc, subtitle, className }) => {
  const classes = classNames({
    'signup-layout-title': true,
    [className]: !!className,
  });

  const { marcomUrl } = getConfig();

  return (
    <div data-testid="sign-up-layout-title" className={classes}>
      <div className="signup-layout-title-subtitle">
        <Logo externalLink linksTo={marcomUrl} />
        {subtitle}
      </div>
      <div className="w-100 d-flex justify-content-between align-items-center mb-2">
        <h2 className="mb-0 d-none d-md-block">{title}</h2>
        <h3 className="mb-0 d-md-none">{title}</h3>
        <div className="d-flex justify-content-center">
          <Logo logoSrc={logoSrc} externalLink linksTo={marcomUrl} />
        </div>
      </div>
    </div>
  );
};

Title.propTypes = propTypes;

export default Title;
